jQuery(document).ready(function ($) {
  var $accordionItems = $(".product-details .productView-details .accordion-item");
  var $accordionAnswers = $(".product-details .productView-details .accordion-item .accordion-answer");
  
  // Hide all answers initially
  $accordionAnswers.hide();
  
  // Add click handlers
  $(".product-details .productView-details .accordion-item .accordion-question").click(function (e) {
    e.preventDefault();
    
    var $currentItem = $(this).closest(".accordion-item");
    var $currentAnswer = $currentItem.find(".accordion-answer");
    var isActive = $currentItem.hasClass("active");
    
    // Close all other items
    $accordionItems.not($currentItem).removeClass("active");
    $accordionAnswers.not($currentAnswer).slideUp(300);
    
    // Toggle current item
    if (isActive) {
      $currentItem.removeClass("active");
      $currentAnswer.slideUp(300);
    } else {
      $currentItem.addClass("active");
      $currentAnswer.slideDown(300);
    }
  });

  // // custom qty selector pdp
  // const container = document.getElementById('BundleSelector');
  // const qtyInput = document.querySelector('.quantity__input');

  // if (!container || !qtyInput) return;

  // const grid = container.querySelector('.bundle-grid');
  // const basePrice = window.productBasePrice || 0;

  // function initBundle() {

  //   const rows = document.querySelectorAll(
  //     '.discounty-volume-discount-widget__table tbody tr'
  //   );

  //   if (!rows.length) return false;

  //   const combined = [];

  //   // ✅ Always include default 1 tier
  //   combined.push({ min: 1, discount: 0 });

  //   rows.forEach(row => {

  //     const qtyText = row.querySelector(
  //       '.discounty-volume-discount-widget__criteria'
  //     )?.innerText || '';

  //     const discountText = row.querySelector(
  //       '.discounty-volume-discount-widget__discount'
  //     )?.innerText || '';

  //     const qty = parseInt(qtyText.replace(/\D/g, ''));
  //     const discount = parseFloat(discountText.replace(/[^\d.]/g, ''));

  //     if (!isNaN(qty) && !isNaN(discount)) {
  //       combined.push({ min: qty, discount: discount });
  //     }
  //   });

  //   combined.sort((a, b) => a.min - b.min);

  //   grid.innerHTML = '';

  //   combined.forEach(item => {

  //     const card = document.createElement('div');
  //     card.className = 'bundle-card';
  //     card.dataset.min = item.min;
  //     card.dataset.discount = item.discount;

  //     card.innerHTML = `
  //       <h4 class="card-bundle-title">${item.min}+ BALLS</h4>
  //       <div class="bundle-price"></div>
  //       <span class="save-badge"></span>
  //     `;

  //     grid.appendChild(card);
  //   });

  //   const bundleCards = [...grid.querySelectorAll('.bundle-card')];

  //   function detectTier(qty) {
  //     let active = bundleCards[0];

  //     bundleCards.forEach(card => {
  //       if (qty >= parseInt(card.dataset.min)) {
  //         active = card;
  //       }
  //     });

  //     return active;
  //   }

  //   function updateBundle(qty) {

  //     const active = detectTier(qty);

  //     bundleCards.forEach(card => card.classList.remove('active'));
  //     active.classList.add('active');

  //     const discount = parseFloat(active.dataset.discount);
  //     const discountedUnit = basePrice - (basePrice * discount / 100);
  //     const saved = (basePrice - discountedUnit) * qty;

  //     bundleCards.forEach(card => {
  //       const d = parseFloat(card.dataset.discount);
  //       const unit = basePrice - (basePrice * d / 100);
  //       card.querySelector('.bundle-price').innerHTML =
  //         '$' + unit.toFixed(2) + ' <span class="prefix">/ea</span>';
  //     });

  //     active.querySelector('.save-badge').innerHTML =
  //       discount > 0 ? `Save $${saved.toFixed(2)}` : '';

  //     // Update main price (unit price only)
  //     const priceEl = document.querySelector('.price.price--medium');
  //     if (priceEl) {
  //       priceEl.innerHTML = '$' + discountedUnit.toFixed(2);
  //     }
  //   }

  //   function handleQtyChange() {
  //     const qty = parseInt(qtyInput.value) || 1;
  //     updateBundle(qty);
  //   }

  //   // Input typing
  //   qtyInput.addEventListener('input', handleQtyChange);
  //   qtyInput.addEventListener('change', handleQtyChange);

  //   // Plus / Minus (Ella)
  //   document.addEventListener('click', function(e) {
  //     if (e.target.closest('.btn-quantity')) {
  //       setTimeout(handleQtyChange, 50);
  //     }
  //   });

  //   // Tier click
  //   bundleCards.forEach(card => {
  //     card.addEventListener('click', function () {
  //       qtyInput.value = this.dataset.min;
  //       qtyInput.dispatchEvent(new Event('change'));
  //     });
  //   });

  //   // ✅ Force default quantity 1
  //   qtyInput.value = 1;
  //   updateBundle(1);

  //   return true;
  // }

  // // Wait until Discounty loads
  // const observer = new MutationObserver(() => {
  //   if (initBundle()) {
  //     observer.disconnect();
  //   }
  // });

  // observer.observe(document.body, {
  //   childList: true,
  //   subtree: true
  // });
});

(function () {
  const mobileMediaQuery = window.matchMedia('(max-width: 767px)');
  const stickyMediaEnabledClass = 'deploy-teamatical-sticky-media-enabled';
  const stickyMediaActiveClass = 'deploy-teamatical-sticky-media-active';
  const stickyMediaTopGap = 10;
  const personalizationTextSelector = [
    '.ella-teamatical-input',
    '.ella-teamatical-textbox',
    '.line-item-property__field input[type="text"]',
    '.productView-details input[type="text"]',
    '.productView-details textarea'
  ].join(', ');
  let stickyMediaUpdateFrame = null;

  function isSummerTeamwearProduct() {
    return document.body.classList.contains('template-product-summer-teamwear') ||
      document.body.classList.contains('template-product-summer-teamwear-grip-socks');
  }

  function isMobileProductView() {
    return isSummerTeamwearProduct() && mobileMediaQuery.matches;
  }

  function getProductView(target) {
    if (target instanceof Element) {
      const productView = target.closest('.productView');

      if (productView) return productView;
    }

    return document.querySelector('.product-details .productView');
  }

  function getMainGallery(productView) {
    if (!productView) return null;

    return productView.querySelector('[data-image-gallery-main]');
  }

  function getScrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function getStickyHeaderOffset() {
    const header = document.getElementById('shopify-section-header');

    if (!header || !header.classList.contains('shopify-section-header-sticky')) return 0;

    const headerBounds = header.getBoundingClientRect();

    return Math.max(0, Math.round(headerBounds.bottom));
  }

  function getKeyboardViewportOffset() {
    if (!window.visualViewport) return 0;
    if (!(document.activeElement instanceof Element)) return 0;
    if (!document.activeElement.matches(personalizationTextSelector)) return 0;

    return Math.max(0, Math.round(window.visualViewport.offsetTop || 0));
  }

  function getTeamaticalStickyTop() {
    return getStickyHeaderOffset() + getKeyboardViewportOffset() + stickyMediaTopGap;
  }

  function getStickyMediaTriggerY(mediaColumn) {
    const triggerY = Number(mediaColumn.dataset.deployTeamaticalStickyTriggerY);

    return Number.isFinite(triggerY) ? triggerY : null;
  }

  function setStickyMediaTriggerY(mediaColumn) {
    if (getStickyMediaTriggerY(mediaColumn) !== null) return;

    const mediaTop = Math.round(mediaColumn.getBoundingClientRect().top + getScrollTop());

    mediaColumn.dataset.deployTeamaticalStickyTriggerY = String(Math.max(0, mediaTop));
  }

  function refreshProductGallerySlick(productView) {
    if (!productView || !window.jQuery) return;

    window.jQuery(productView).find('[data-image-gallery-main], .productView-for').each((index, slider) => {
      const $slider = window.jQuery(slider);

      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('setPosition');
      }
    });
  }

  function updateTeamaticalGallerySwipe(productView) {
    const mainGallery = getMainGallery(productView);

    if (!mainGallery || !window.jQuery) return;

    const $mainGallery = window.jQuery(mainGallery);

    if (!$mainGallery.hasClass('slick-initialized')) return;

    const shouldDisableSwipe = isMobileProductView() && !!productView.querySelector('.media.teamatical-disabled-pointer-events');
    const swipeState = shouldDisableSwipe ? 'disabled' : 'enabled';

    if (mainGallery.dataset.deployTeamaticalSwipeState === swipeState) return;

    mainGallery.dataset.deployTeamaticalSwipeState = swipeState;
    mainGallery.classList.toggle('deploy-teamatical-gallery-swipe-disabled', shouldDisableSwipe);
    $mainGallery.slick('slickSetOption', {
      draggable: !shouldDisableSwipe,
      swipe: !shouldDisableSwipe,
      touchMove: !shouldDisableSwipe
    }, false);
  }

  function updateTeamaticalStickyMedia() {
    const productView = document.querySelector('.product-details .productView');
    const mediaColumn = productView ? productView.querySelector('.halo-productView-left') : null;

    if (!mediaColumn) return;

    const wasCompact = mediaColumn.classList.contains(stickyMediaActiveClass);

    updateTeamaticalGallerySwipe(productView);

    if (!isMobileProductView() || !mediaColumn.querySelector('.media.teamatical-disabled-pointer-events')) {
      mediaColumn.classList.remove(stickyMediaEnabledClass, stickyMediaActiveClass);
      delete mediaColumn.dataset.deployTeamaticalStickyTriggerY;
      document.documentElement.style.removeProperty('--deploy-teamatical-sticky-top');

      if (wasCompact) {
        window.requestAnimationFrame(() => {
          refreshProductGallerySlick(productView);
        });
      }

      return;
    }

    if (!mediaColumn.classList.contains(stickyMediaEnabledClass)) {
      mediaColumn.classList.remove(stickyMediaActiveClass);
      document.documentElement.style.removeProperty('--deploy-teamatical-sticky-top');

      if (wasCompact) {
        window.requestAnimationFrame(() => {
          refreshProductGallerySlick(productView);
        });
      }

      return;
    }

    const stickyTop = getTeamaticalStickyTop();
    const triggerY = getStickyMediaTriggerY(mediaColumn);
    const shouldCompact = triggerY === null || getScrollTop() > triggerY + 1;

    document.documentElement.style.setProperty('--deploy-teamatical-sticky-top', `${stickyTop}px`);
    mediaColumn.classList.toggle(stickyMediaActiveClass, shouldCompact);

    if (!wasCompact && shouldCompact) {
      goToTeamaticalRender(mediaColumn);
    }

    if (wasCompact !== shouldCompact) {
      window.requestAnimationFrame(() => {
        refreshProductGallerySlick(productView);
      });
    }
  }

  function enableTeamaticalStickyMedia(target) {
    if (!isMobileProductView()) return;

    const productView = getProductView(target);
    const mediaColumn = productView ? productView.querySelector('.halo-productView-left') : null;

    if (!mediaColumn || !mediaColumn.querySelector('.media.teamatical-disabled-pointer-events')) return;

    setStickyMediaTriggerY(mediaColumn);
    document.documentElement.style.setProperty('--deploy-teamatical-sticky-top', `${getTeamaticalStickyTop()}px`);
    mediaColumn.classList.add(stickyMediaEnabledClass);
    goToTeamaticalRender(target);
    queueTeamaticalStickyMediaUpdate();
  }

  function queueTeamaticalStickyMediaUpdate() {
    if (stickyMediaUpdateFrame) return;

    stickyMediaUpdateFrame = window.requestAnimationFrame(() => {
      stickyMediaUpdateFrame = null;
      updateTeamaticalStickyMedia();
    });
  }

  function getMainGallerySlides(mainGallery) {
    if (!mainGallery || !window.jQuery) return [];

    const $mainGallery = window.jQuery(mainGallery);

    if ($mainGallery.hasClass('slick-initialized')) {
      const slick = $mainGallery.slick('getSlick');

      return Array.from(slick.$slides || []);
    }

    return Array.from(mainGallery.children);
  }

  function resetProductGalleryVideos(productView) {
    if (typeof window.pauseAllMedia === 'function') {
      window.pauseAllMedia();
    }

    productView.querySelectorAll('[data-product-gallery-video].is-playing').forEach((videoWrapper) => {
      const player = videoWrapper.querySelector('video');

      if (player) {
        try {
          player.currentTime = 0;
        } catch (error) {}
      }

      videoWrapper.classList.remove('is-playing');

      const playerRegion = videoWrapper.querySelector('[data-product-gallery-video-player]');

      if (playerRegion) {
        playerRegion.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function playProductGalleryVideo(videoWrapper) {
    if (!videoWrapper) return false;

    const productView = getProductView(videoWrapper);
    const player = videoWrapper.querySelector('video');

    if (!productView || !player) return false;

    productView.querySelectorAll('[data-product-gallery-video].is-playing').forEach((activeVideoWrapper) => {
      if (activeVideoWrapper !== videoWrapper) {
        resetProductGalleryVideos(productView);
      }
    });

    if (typeof window.pauseAllMedia === 'function') {
      window.pauseAllMedia();
    }

    player.setAttribute('playsinline', '');
    player.setAttribute('webkit-playsinline', '');
    videoWrapper.classList.add('is-playing');

    const playerRegion = videoWrapper.querySelector('[data-product-gallery-video-player]');

    if (playerRegion) {
      playerRegion.setAttribute('aria-hidden', 'false');
    }

    const playPromise = player.play();

    if (playPromise !== undefined) {
      playPromise.catch(() => {
        resetProductGalleryVideos(productView);
      });
    }

    return true;
  }

  function goToMainGallerySlide(productView, predicate) {
    const mainGallery = getMainGallery(productView);

    if (!mainGallery || !window.jQuery) return false;

    const slides = getMainGallerySlides(mainGallery);
    const slideIndex = slides.findIndex(predicate);

    if (slideIndex < 0) return false;

    resetProductGalleryVideos(productView);
    const slide = slides[slideIndex];

    const $mainGallery = window.jQuery(mainGallery);

    if ($mainGallery.hasClass('slick-initialized')) {
      $mainGallery.slick('slickGoTo', slideIndex);

      return slide;
    }

    slides.forEach((slide, index) => {
      slide.style.display = index === slideIndex ? '' : 'none';
    });

    return slide;
  }

  function getThumbnailMediaId(thumbnail) {
    if (!thumbnail) return '';

    const fullMediaId = thumbnail.getAttribute('data-media-id');

    if (!fullMediaId) return '';

    return fullMediaId.split('-').pop();
  }

  function updateSelectedThumbnail(productView, mediaId) {
    const thumbnailWrapper = productView.querySelector('.productView-thumbnail-wrapper');

    if (!thumbnailWrapper) return;

    thumbnailWrapper.classList.toggle('deploy-thumbnail-selection-active', !!mediaId);
    thumbnailWrapper.querySelectorAll('.deploy-selected-thumbnail').forEach((thumbnail) => {
      thumbnail.classList.remove('deploy-selected-thumbnail');
    });

    if (!mediaId) return;

    thumbnailWrapper.querySelectorAll(`.productView-thumbnail[data-media-id$="-${mediaId}"]`).forEach((thumbnail) => {
      thumbnail.classList.add('deploy-selected-thumbnail');
    });
  }

  function goToSelectedThumbnailMedia(thumbnail) {
    if (!isMobileProductView()) return;

    const mediaId = getThumbnailMediaId(thumbnail);
    const productView = getProductView(thumbnail);

    if (!mediaId || !productView) return;

    const selectedSlide = goToMainGallerySlide(productView, (slide) => {
      return !!slide.querySelector(`.productView-img-container[data-media-id="${mediaId}"]`);
    });

    if (selectedSlide) {
      updateSelectedThumbnail(productView, mediaId);
    }

    return selectedSlide;
  }

  function goToTeamaticalRender(target) {
    if (!isMobileProductView()) return;

    const productView = getProductView(target);

    if (!productView) return;

    const selectedSlide = goToMainGallerySlide(productView, (slide) => {
      return !!slide.querySelector('.media.teamatical-disabled-pointer-events');
    });

    if (selectedSlide) {
      updateSelectedThumbnail(productView, '');
    }

    return selectedSlide;
  }

  window.addEventListener('scroll', queueTeamaticalStickyMediaUpdate, { passive: true });
  window.addEventListener('resize', queueTeamaticalStickyMediaUpdate);
  window.addEventListener('orientationchange', queueTeamaticalStickyMediaUpdate);
  window.addEventListener('load', queueTeamaticalStickyMediaUpdate);
  document.addEventListener('DOMContentLoaded', queueTeamaticalStickyMediaUpdate);

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', queueTeamaticalStickyMediaUpdate, { passive: true });
    window.visualViewport.addEventListener('scroll', queueTeamaticalStickyMediaUpdate, { passive: true });
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const playButton = event.target.closest('[data-product-gallery-video-play]');

    if (playButton && mobileMediaQuery.matches) {
      const videoWrapper = playButton.closest('[data-product-gallery-video]');

      if (!videoWrapper) return;

      event.preventDefault();
      event.stopPropagation();
      playProductGalleryVideo(videoWrapper);

      return;
    }

    const thumbnail = event.target.closest('.productView-thumbnail[data-media-id]');

    if (!thumbnail) return;
    if (!isMobileProductView()) return;

    const selectedSlide = goToSelectedThumbnailMedia(thumbnail);

    if (!selectedSlide) return;

    event.preventDefault();
    event.stopPropagation();

    const selectedVideo = selectedSlide.querySelector('[data-product-gallery-video]');

    if (selectedVideo) {
      playProductGalleryVideo(selectedVideo);
    }

    queueTeamaticalStickyMediaUpdate();
  }, true);

  document.addEventListener('input', (event) => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.matches(personalizationTextSelector)) return;

    enableTeamaticalStickyMedia(event.target);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.matches(personalizationTextSelector)) return;

    enableTeamaticalStickyMedia(event.target);
  }, true);

  queueTeamaticalStickyMediaUpdate();
  window.setTimeout(queueTeamaticalStickyMediaUpdate, 500);
})();
